/** Pure formatting helpers for the assistant surfaces. Extracted from `src/pages/Ask.tsx`
 *  unchanged — kept together and free of React so they stay directly testable. */

/** Fraction of the monthly allowance used. Unlimited (or a nonsense quota) reads as 0. */
export function usagePct(used: number, quota: number | null): number {
  if (quota == null || quota <= 0) return 0;
  return used / quota;
}

/** "0.8s", "3.2s", "1m 04s" — compact elapsed-time label for a think duration. */
export function durationLabel(ms: number): string {
  if (ms < 1000) return `${(ms / 1000).toFixed(1)}s`;
  const secs = ms / 1000;
  if (secs < 60) return `${secs.toFixed(1)}s`;
  const m = Math.floor(secs / 60);
  const s = Math.round(secs % 60);
  return `${m}m ${String(s).padStart(2, '0')}s`;
}

/** Short, human relative-ish label for a thread's last-activity timestamp. */
export function whenLabel(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const days = Math.floor((Date.now() - then) / 86_400_000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
